<style lang="scss" scoped>
.slide-1 {
  background-image: url(../../../assets/module3/slide1/background-01.jpg);
  background-color: #fff;
  background-size: cover;
  background-position: center;
  position: relative;
  height: 100%;
  padding-top: 30px;

  .heading1,
  .heading2 {
    font-size: 100px;
    color: #c5d43b;
    margin-left: 20%;
    transform: rotate(-5deg);
  }
  .heading2 {
    margin-left: 30%;
    transform: rotate(-4deg);
  }

  .heading3 {
    font-size: 60px;
    color: #3b7fc2;
  }

  .page {
    margin-top: 50px;
  }

  .copy {
    color: #000;
    margin-bottom: 1.5em;
  }
}
</style>

<template>
  <div class="slide-1">
    <h1 class="heading1" v-html="$t('module3.slide1.heading1')"></h1>
    <h1 class="heading2" v-html="$t('module3.slide1.heading2')"></h1>
    <div class="pages">
      <div class="page page-left"></div>
      <div class="page page-right">
        <p v-html="$t('module3.slide1.copy1')" class="copy"></p>
        <p v-html="$t('module3.slide1.copy2')" class="copy"></p>
        <p v-html="$t('module3.slide1.copy3')" class="copy"></p>
        <h1 class="heading3" v-html="$t('module3.slide1.heading3')"></h1>
      </div>
      <img src="@/assets/module3/slide1/armando-01.png" alt="" class="chars" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
